@let problemResponse = problemResponse$ | async;

<div class="navigator-container">
    <div class="d-flex justify-content-between align-items-center gap-2">
        <div class="responsive-button-grid">
            <a
                class="btn btn-outline-primary btn-sm"
                [class.disabled]="problemResponse?.problem?.id === problemResponse?.first"
                [routerLink]="['/', 'annotate', problemResponse?.first]"
                queryParamsHandling="preserve"
                aria-labelledby="label-first"
                title="First problem"
                title-i18n
            >
                <fa-icon
                    [icon]="faAnglesLeft"
                    aria-hidden="true"
                    focusable="false"
                />
                <span id="label-first" class="visually-hidden" i18n>
                    First</span
                >
            </a>
            <a
                class="btn btn-outline-primary btn-sm"
                [class.disabled]="problemResponse?.previous === null"
                [routerLink]="['/', 'annotate', problemResponse?.previous]"
                queryParamsHandling="preserve"
                aria-labelledby="label-previous"
                title="Previous problem"
                title-i18n
            >
                <fa-icon
                    [icon]="faAngleLeft"
                    aria-hidden="true"
                    focusable="false"
                />
                <span id="label-previous" class="visually-hidden" i18n
                    >Previous</span
                >
            </a>
        </div>

        <div class="px-2 text-center flex-grow-1">
            @if (problemResponse) {
            <span class="small" i18n>
                {{ problemResponse?.index ?? "-" }}
            </span>
            <hr class="my-1">
            <span class="small" i18n>{{ problemResponse.total }}</span>
            }
        </div>

        <div class="responsive-button-grid">
            <a
                class="btn btn-outline-primary btn-sm"
                [class.disabled]="problemResponse?.next === null"
                [routerLink]="['/', 'annotate', problemResponse?.next]"
                queryParamsHandling="preserve"
                aria-labelledby="label-next"
                title="Next problem"
                title-i18n
            >
                <span id="label-next" class="visually-hidden" i18n>Next</span>
                <fa-icon
                    [icon]="faAngleRight"
                    aria-hidden="true"
                    focusable="false"
                />
            </a>
            <a
                class="btn btn-outline-primary btn-sm"
                [class.disabled]="problemResponse?.problem?.id === problemResponse?.last"
                [routerLink]="['/', 'annotate', problemResponse?.last]"
                queryParamsHandling="preserve"
                aria-labelledby="label-last"
                title="Last problem"
                title-i18n
            >
                <span id="label-last" class="visually-hidden" i18n>Last</span>
                <fa-icon
                    [icon]="faAnglesRight"
                    aria-hidden="true"
                    focusable="false"
                />
            </a>
        </div>
    </div>
</div>
